import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { SubmissionService } from '../../../../../../http/intake/submission.service';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { Subject, takeUntil } from 'rxjs';
import { IntakeConstant } from '../../../../../constants/intake.constant';
import { RoleService } from '../../../../../../http/intake/role.service';
import {
  DocumentStatus,
  IntakeDocumentStatusIdMapper,
} from '../../../../../constants/document-status.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonHelperService } from '../../../../../../common/services/common-helper.service';
import {
  INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES,
  updateDocStatusDropdown,
} from '../../document-settings';
import {
  IntakeDocumentType,
  IntakeDocumentTypeToIdMapper,
} from '../../../../../constants/intake-document-type.enum';

@Component({
  selector: 'app-document-edit-popup',
  templateUrl: './document-edit-popup.component.html',
  styleUrl: './document-edit-popup.component.less',
})
export class DocumentEditPopupComponent implements OnInit {
  @Input() public documentInitiatedDetails: any = {};
  @Input() rmReviewedGuidanceNoteHeader!: string;
  @Input() rmReviewedGuidanceNoteBody!: string;
  @Input() documentTypeOptions: SelectItemOptions[] = [];
  @Input() set setDocumentStatusOptions(value: SelectItemOptions[]) {
    this.documentStatusOptions = value;
    this.allStatusAvailable = value;
  }

  private readonly unsubscriber$: Subject<void> = new Subject<void>();

  constructor(
    public readonly modalService: ModalService,
    private readonly intakeDetailService: SubmissionService,
    private readonly roleService: RoleService,
    private readonly commonHelperService: CommonHelperService
  ) {}

  documentTitle: string = this.documentInitiatedDetails.documentTitle;
  documentComment: string = this.documentInitiatedDetails.comments;

  documentStatusOptions: SelectItemOptions[] = [];
  allStatusAvailable: SelectItemOptions[] = [];

  selectedDocType: number = 0;
  selectedDocStatus: number = 0;

  isSaveDisabled: boolean = false;
  otherStatus: number = IntakeDocumentTypeToIdMapper[IntakeDocumentType.Other];
  loggedInUserRoles: string[] = [];

  InternalRmReviewedDocStatusAllowedRoles: string[] =
    INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES;
  showRMReviewedGuidanceNote: boolean = false;

  ngOnInit(): void {
    this.documentTitle = this.documentInitiatedDetails.documentTitle;
    this.documentComment = this.commonHelperService.trimPrefixEmptySpace(
      this.documentInitiatedDetails.comments
    );
    this.selectedDocType = this.documentInitiatedDetails.documentTypeId;
    this.selectedDocStatus = this.documentInitiatedDetails.documentStatusId;

    this.roleService.currentUserRole$
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: string[]) => {
          this.loggedInUserRoles = response;
        },
      });

    this.prepopulateTypeDropdown();
    this.prepopulateStatusDropdown();
  }

  async editDocument(): Promise<void> {
    const postRequestData = {
      submissionDocumentId: this.documentInitiatedDetails.submissionDocumentId,
      submissionId: this.documentInitiatedDetails.submissionId,
      documentTypeId: this.selectedDocType,
      documentStatusId: this.selectedDocStatus,
      submissionDocumentTypeId:
        this.documentInitiatedDetails.submissionDocumentTypeId,
      documentTitle: this.commonHelperService.trimPrefixEmptySpace(
        this.documentTitle
      ),
      comments: this.commonHelperService.trimPrefixEmptySpace(
        this.documentComment
      ),
      modifiedBy: IntakeConstant.EMPTY_SPACE,
      attachmentId: this.documentInitiatedDetails.attachmentId,
    };
    return new Promise((resolve, reject) => {
      this.intakeDetailService
        .postDocumentEdit(postRequestData)
        .pipe(takeUntil(this.unsubscriber$))
        .subscribe({
          next: () => {
            resolve();
          },
          error: (err: HttpErrorResponse) => {
            console.error('An error occurred during document edit:', err);
            reject(new Error(err.message));
          },
        });
    });
  }

  async closeAll(): Promise<void> {
    try {
      await this.editDocument();
    } catch (error: any) {
      console.error(error);
    }
    this.close();
  }

  close(): void {
    this.modalService.close();
  }

  onDocTypeChange(event: any): void {
    this.updateStatusDropdown();
  }

  onDocStatusChange(): void {
    const rmReviewdId = IntakeDocumentStatusIdMapper.get(
      DocumentStatus.RMReviewed
    );
    this.showRMReviewedGuidanceNote = this.selectedDocStatus === rmReviewdId;
    this.isSaveDisabled = false;
  }
  updateStatusDropdown(): void {
    const { statusOptions, selectedDocStatus } = updateDocStatusDropdown(
      this.allStatusAvailable,
      this.documentInitiatedDetails.submissionTypeCode,
      this.documentInitiatedDetails.submissionStatus,
      this.selectedDocType,
      this.selectedDocStatus
    );

    this.documentStatusOptions = statusOptions;
    if (selectedDocStatus !== null) {
      this.selectedDocStatus = selectedDocStatus;
      if (selectedDocStatus === 0) {
        this.isSaveDisabled = true;
      }
    }
  }
  prepopulateTypeDropdown(): void {
    this.selectedDocType = this.documentInitiatedDetails.documentTypeId;
    this.updateStatusDropdown();
  }

  prepopulateStatusDropdown(): void {
    this.selectedDocStatus = this.documentInitiatedDetails.documentStatusId;
    this.onDocStatusChange();
  }

  isSaveDisabledCheck(): boolean {
    if (this.selectedDocType === this.otherStatus) {
      if (this.documentComment.length > 0 && !this.isSaveDisabled) {
        return false;
      }
      return true;
    }
    return this.isSaveDisabled;
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
